var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-discord",
    "data-name": "Icon awesome-discord",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.242,
    height: 122.562,
    viewBox: "0 0 107.242 122.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-discord-2",
    "data-name": "Icon awesome-discord",
    d: "M71.147,58.217a6.273,6.273,0,1,1-6.251-6.8A6.529,6.529,0,0,1,71.147,58.217Zm-28.618-6.8a6.827,6.827,0,0,0,0,13.6,6.529,6.529,0,0,0,6.251-6.8A6.489,6.489,0,0,0,42.529,51.415Zm64.713-38.791V122.562c-15.439-13.643-10.5-9.127-28.434-25.8L82.055,108.1H12.563A12.593,12.593,0,0,1,0,95.476V12.624A12.593,12.593,0,0,1,12.563,0H94.679A12.593,12.593,0,0,1,107.242,12.624ZM89.777,70.718c0-19.732-8.824-35.727-8.824-35.727-8.824-6.618-17.22-6.435-17.22-6.435l-.858.98c10.418,3.187,15.259,7.783,15.259,7.783a52.07,52.07,0,0,0-45.777-1.777c-2.267,1.042-3.616,1.777-3.616,1.777s5.086-4.841,16.117-8.028l-.613-.735s-8.4-.184-17.22,6.434c0,0-8.824,15.994-8.824,35.727,0,0,5.148,8.886,18.691,9.315,0,0,2.267-2.758,4.106-5.086-7.783-2.329-10.724-7.231-10.724-7.231.9.631,2.388,1.449,2.513,1.532a44.67,44.67,0,0,0,38.239,2.145,35.067,35.067,0,0,0,7.047-3.616S75.008,72.8,66.98,75.069c1.838,2.329,4.045,4.964,4.045,4.964C84.568,79.6,89.777,70.718,89.777,70.718Z",
    fill: "#6aa5ac"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.2f4a8a84643a7ad72d00c81899415286.svg";
export { ForwardRef as ReactComponent };